function UploadIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          fill='currentColor'
          d='M15.7929 3.29289C16.1834 2.90237 16.8166 2.90237 17.2071 3.29289L22.2071 8.29289C22.5976 8.68342 22.5976 9.31658 22.2071 9.70711C21.8166 10.0976 21.1834 10.0976 20.7929 9.70711L16.5 5.41421L12.2071 9.70711C11.8166 10.0976 11.1834 10.0976 10.7929 9.70711C10.4024 9.31658 10.4024 8.68342 10.7929 8.29289L15.7929 3.29289Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          fill='currentColor'
          d='M16.5 3C17.0523 3 17.5 3.44772 17.5 4V16C17.5 16.5523 17.0523 17 16.5 17C15.9477 17 15.5 16.5523 15.5 16V4C15.5 3.44772 15.9477 3 16.5 3Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          fill='currentColor'
          d='M16.5 7C17.0523 7 17.5 7.44772 17.5 8V20C17.5 20.5523 17.0523 21 16.5 21C15.9477 21 15.5 20.5523 15.5 20V8C15.5 7.44772 15.9477 7 16.5 7Z'
        />
        <path
          d='M3.5 18V24C3.5 26.2091 5.29086 28 7.5 28H25.5C27.7091 28 29.5 26.2091 29.5 24V18'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          fill='none'
        />
      </svg>
    </span>
  );
}

export default UploadIcon;
